module.exports = __webpack_public_path__ + "img/31.cbabb4b9.jpg";